export const positionsStoreKey = 'positions';
